export default "__VITE_ASSET__CP54i9Pq__"